import { Highlightable } from '@angular/cdk/a11y';
import { Component, HostBinding, Input, OnInit, ViewChildren } from '@angular/core';


export class ListItemComponent implements Highlightable {
   item;
   disabled = false;
  private _isActive = false;

  setActiveStyles() {
    this._isActive = true;
  }

  setInactiveStyles() {
    this._isActive = false;
  }

  getLabel() {
    return this.item;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
'disabled': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
